import { ProductSpecDto } from './specs';

export class ProductSwapDto {
  id: string;
  type: string;
  referenceProduct: ProductSpecDto;

  constructor(d?: ProductSwapDto) {
    if (!d) {
      return;
    }

    this.id = d.id;
    this.type = d.type;
    if (d.referenceProduct) {
      this.referenceProduct = new ProductSpecDto(d.referenceProduct);
    }
  }
}
